function LoaderFallback(): JSX.Element {
  return (
    <div>
      <h1 style={{ margin: 0 }}>JAYDE MITCHELL</h1>
      <div style={{ textAlign: 'right' }}>0</div>
    </div>
  );
}

export default LoaderFallback;